const SAVED_VIEW_SETTING_KEYS = [
    'gridSize',
    'gridColor',
    'viewMode',
    'showHeadline',
    'showRating',
    'showFilenames',
    'showIcons',
    'autoPlay',
]

const buildViewSettingsDefaults = ({mobile = false, organizationSettings = {}} = {}) => ({
    gridSize: mobile ? 'xl' : 'm',
    gridColor: '#ffffff',
    viewMode: 'grid',
    showFilenames: false,
    showHeadline: false,
    autoPlay: false,
    convertSpacesToOr: false,
    convertCommasToOr: false,
    showIcons: true,
    showRating: false,
    colorLabel: null,
    ...(organizationSettings || {}),
})

const selectSavedViewSettings = (settings = {}) => Object.fromEntries(
    SAVED_VIEW_SETTING_KEYS.map(key => [key, settings[key]])
)

const resolveViewSettings = ({
    defaults = {},
    sessionSettings = {},
    assetGroupSettings = {},
    manual = false,
}) => ({
    ...defaults,
    ...sessionSettings,
    ...(manual ? {} : (assetGroupSettings || {})),
})

const hasAssetGroupViewSettingsChanges = ({value, defaults = {}, assetGroupSettings = {}}) => {
    const persistedDefault = {...defaults, ...(assetGroupSettings || {})}

    return SAVED_VIEW_SETTING_KEYS.some(key => value[key] !== persistedDefault[key])
}

export {
    SAVED_VIEW_SETTING_KEYS,
    buildViewSettingsDefaults,
    hasAssetGroupViewSettingsChanges,
    resolveViewSettings,
    selectSavedViewSettings,
}
